<style src="../assets/css/propos.css" scoped></style>

<template>

<div class="heroBg">
  <main class="container">
    <section class="hero">
      <div>
        <h1>Le projet</h1>
        <p class="lead">
          Asso-Refuge est un projet indépendant dont l’objectif est simple :
          <span class="hl">aider les refuges à gagner en visibilité</span> et
          <span class="hl">faciliter l’adoption</span>,
          sans leur imposer de contraintes techniques, financières ou publicitaires.
        </p>

        <div class="promise">
          ✅ Sites <span class="hl">100% gratuits</span> • ✅ <span class="hl">Hébergement inclus</span> • ✅ <span class="hl">Aucune publicité</span>
          <small>Les refuges gardent leur identité, le contact reste direct.</small>
        </div>
      </div>

      <aside class="heroCard">
        <div class="badge"><span class="dot"></span> Un site dédié + une plateforme centrale</div>
        <p>
          Chaque refuge partenaire a son <span class="hl">site personnalisé à son nom</span>,
          et bénéficie d’une <span class="hl">exposition supplémentaire</span> via Asso-Refuge.
        </p>
        <div class="ctaRow">
          <RouterLink to="/contact" class="nav-link linkBtn primary">Contact</RouterLink>
        </div>
      </aside>
    </section>
  </main>
</div>

<main class="container">
  <section class="section">
    <h2>Pourquoi ce projet ?</h2>
    <p>
      Beaucoup de refuges font un travail incroyable, mais manquent de visibilité et d’outils modernes.
      Maintenir un site internet à jour prend du temps et demande des compétences techniques.
    </p>
    <p>
      Asso-Refuge est né pour apporter une solution concrète :
      permettre à chaque refuge d’avoir un site clair et moderne, et regrouper leurs animaux
      sur une plateforme commune pour <span class="hl">maximiser les chances d’adoption</span>.
    </p>
  </section>

  <section class="section">
    <h2>Comment ça fonctionne</h2>

    <div class="steps">
      <div class="step">
        <div class="num">1</div>
        <strong>Un site au nom du refuge</strong>
        <span>Création gratuite, hébergement inclus, sans pub.</span>
      </div>

      <div class="step">
        <div class="num">2</div>
        <strong>Les animaux sont publiés</strong>
        <span>Pages propres, faciles à partager, adaptées mobile.</span>
      </div>

      <div class="step">
        <div class="num">3</div>
        <strong>Double visibilité</strong>
        <span>Site du refuge + plateforme Asso-Refuge.</span>
      </div>
    </div>

    <div class="bigCta">
      <h3>Vous êtes un refuge ? On peut mettre en ligne votre site gratuitement.</h3>
      <p>Vous gardez votre identité, et vos animaux gagnent en visibilité sur la plateforme.</p>
      <div class="ctaRow">
      <RouterLink to="/contact" class="nav-link linkBtn primary">Contact</RouterLink>
      </div>
    </div>
  </section>

  <section class="section">
    <h2>Des données fiables et à jour</h2>
    <p>
      Tous les refuges partenaires ont un site que je conçois et que je gère moi-même.
      Résultat : les données sont disponibles <span class="hl">directement</span>, sans copier-coller ni saisie manuelle.
    </p>
    <ul>
      <li>Informations <span class="hl">centralisées</span> et cohérentes</li>
      <li>Mises à jour <span class="hl">simples</span> et rapides</li>
      <li>Moins d’erreurs, moins d’obsolescence</li>
      <li>Plus de temps pour le refuge, plus de clarté pour les visiteurs</li>
    </ul>
  </section>

  <section class="section">
    <h2>Une démarche respectueuse</h2>
    <p>
      Asso-Refuge n’est pas une plateforme commerciale.
      Les refuges gardent leur identité et le contact reste direct :
      <span class="hl">aucune commission</span>, <span class="hl">aucune publicité</span>, <span class="hl">aucun intermédiaire inutile</span>.
    </p>
    <ul>
      <li>Chaque refuge conserve son site et sa communication</li>
      <li>Chaque animal renvoie vers la fiche et le contact du refuge</li>
      <li>La plateforme agit comme une vitrine et un facilitateur</li>
    </ul>

    <p class="note">
      Vous êtes un refuge et vous souhaitez un site gratuit (hébergement inclus, sans pub) ?
      Cliquez sur  <RouterLink to="/contact">“Devenir refuge partenaire”.</RouterLink>
    </p>
  </section>
</main>

</template>